import client from "../config/axiosConfig";

export const getVideoFiles = () => client.get("/files?consultation=true");
